export default {
  share: {
    // Général
    root: 'Accueil',
    items: 'éléments',
    folder_count: '{count} dossier | {count} dossiers',
    file_count: '{count} fichier | {count} fichiers',
    and: 'et',
    empty_folder: 'Ce dossier est vide',
    empty_folder_subtitle: 'Aucun fichier n\'a encore été partagé dans ce dossier.',
    download: 'Télécharger',
    download_item: 'Télécharger {name}',
    playlist: 'Playlist',
    now_playing: 'En cours',
    playing_item: 'Lecture {current} sur {total}',
    track_count: '{count} piste | {count} pistes',
    video_count: '{count} vidéo | {count} vidéos',
    image_count: '{count} image | {count} images',
    document_count: '{count} document | {count} documents',
    show_more: 'Voir plus',
    show_less: 'Voir moins',
    close: 'Fermer',

    // Mot de passe
    password_required: 'Mot de passe requis',
    password_required_message: 'Ce partage est protégé par un mot de passe. Veuillez entrer le mot de passe pour accéder au contenu.',
    password: 'Mot de passe',
    access: 'Accéder',
    invalid_password: 'Mot de passe incorrect. Veuillez réessayer.',
    show_password: 'Afficher le mot de passe',
    hide_password: 'Masquer le mot de passe',

    // Erreurs
    expired_title: 'Partage indisponible',
    expired_default: 'Ce partage n\'est plus disponible.',
    expired_message: 'Ce partage a expiré.',
    not_found: 'Ce partage n\'existe pas ou a été supprimé.',
    view_limit_reached: 'Ce partage a atteint sa limite de vues.',
    page_not_found: 'Page introuvable',
    page_not_found_message: 'La page que vous recherchez n\'existe pas.',

    // Visionneuse d'asset
    document_preview_unavailable: 'Aperçu non disponible pour ce type de fichier.',

    // Fichiers liés
    linked_files: 'Fichiers liés',

    // Auth CTA
    login: 'Se connecter',
    register: 'S\'inscrire gratuitement',

    // Attribution
    powered_by: 'Partagé avec',
    powered_by_cta: 'Créez le vôtre',
  },
}
